// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/**
* Desktop Navigation 
*/
.navbar {
    padding: 0;
    margin-top: 35px;
    color: white;
  }
  
  .navbar ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
    position: absolute;
    top: 100%;
    left: 0;
  }
  
  .navbar li {
    position: relative;
  }
  
  .navbar li+li {
    margin-left: 30px;
  }
  
  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: white;
    white-space: nowrap;
    transition: 0.3s;
    text-decoration: none;
  }
  
  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }
  
  .navbar a:before {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -4px;
    left: 0;
    background-color: rgb(241, 137, 241);
    visibility: hidden;
    width: 0px;
    transition: all 0.3s ease-in-out 0s;
  }
  
  .navbar a:hover:before,
  .navbar li:hover>a:before,
  .navbar .active:before {
    visibility: visible;
    width: 25px;
  }
  
  /**
  * Mobile Navigation 
  */
  .mobile-nav-toggle {
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    display: none;
    line-height: 0;
    transition: 0.5s;
    position: fixed;
    right: 15px;
    top: 15px;
  }
  
  @media (max-width: 991px) {
    .mobile-nav-toggle {
      display: block;
    }
  
    .navbar ul {
      display: none;
    }
  }
  
  .navbar-mobile {
    position: fixed;
    overflow: hidden;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    transition: 0.3s;
    z-index: 999;
    margin-top: 0;
  }
  
  .navbar-mobile .mobile-nav-toggle {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  
  .navbar-mobile ul {
    display: block;
    position: absolute;
    top: 55px;
    right: 15px;
    bottom: 45px;
    left: 15px;
    padding: 10px 0;
    overflow-y: auto;
    transition: 0.3s;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.96);
  }
  
  .navbar-mobile li {
    padding: 12px 20px;
  }
  
  .navbar-mobile li+li {
    margin: 0;
  }
  
  .navbar-mobile a,
  .navbar-mobile a:focus {
    font-size: 16px;
    position: relative;
  }

.navbar-mobile .mobile-nav-links {
    display: block; /* Show the links */
}

.navbar ul.hidden {
    display: none; /* Hide the links */
}`, "",{"version":3,"sources":["webpack://./src/styles/NavBar.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;;CAEC;AACD;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,OAAO;IACP,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,mCAAmC;EACrC;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;GAEC;EACD;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;AAEF;IACI,cAAc,EAAE,mBAAmB;AACvC;;AAEA;IACI,aAAa,EAAE,mBAAmB;AACtC","sourcesContent":["/*--------------------------------------------------------------\n# Navigation Menu\n--------------------------------------------------------------*/\n/**\n* Desktop Navigation \n*/\n.navbar {\n    padding: 0;\n    margin-top: 35px;\n    color: white;\n  }\n  \n  .navbar ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    align-items: center;\n    position: absolute;\n    top: 100%;\n    left: 0;\n  }\n  \n  .navbar li {\n    position: relative;\n  }\n  \n  .navbar li+li {\n    margin-left: 30px;\n  }\n  \n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    color: white;\n    white-space: nowrap;\n    transition: 0.3s;\n    text-decoration: none;\n  }\n  \n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n  \n  .navbar a:before {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    bottom: -4px;\n    left: 0;\n    background-color: rgb(241, 137, 241);\n    visibility: hidden;\n    width: 0px;\n    transition: all 0.3s ease-in-out 0s;\n  }\n  \n  .navbar a:hover:before,\n  .navbar li:hover>a:before,\n  .navbar .active:before {\n    visibility: visible;\n    width: 25px;\n  }\n  \n  /**\n  * Mobile Navigation \n  */\n  .mobile-nav-toggle {\n    color: #fff;\n    font-size: 28px;\n    cursor: pointer;\n    display: none;\n    line-height: 0;\n    transition: 0.5s;\n    position: fixed;\n    right: 15px;\n    top: 15px;\n  }\n  \n  @media (max-width: 991px) {\n    .mobile-nav-toggle {\n      display: block;\n    }\n  \n    .navbar ul {\n      display: none;\n    }\n  }\n  \n  .navbar-mobile {\n    position: fixed;\n    overflow: hidden;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    transition: 0.3s;\n    z-index: 999;\n    margin-top: 0;\n  }\n  \n  .navbar-mobile .mobile-nav-toggle {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n  \n  .navbar-mobile ul {\n    display: block;\n    position: absolute;\n    top: 55px;\n    right: 15px;\n    bottom: 45px;\n    left: 15px;\n    padding: 10px 0;\n    overflow-y: auto;\n    transition: 0.3s;\n    z-index: 1000;\n    background: rgba(0, 0, 0, 0.96);\n  }\n  \n  .navbar-mobile li {\n    padding: 12px 20px;\n  }\n  \n  .navbar-mobile li+li {\n    margin: 0;\n  }\n  \n  .navbar-mobile a,\n  .navbar-mobile a:focus {\n    font-size: 16px;\n    position: relative;\n  }\n\n.navbar-mobile .mobile-nav-links {\n    display: block; /* Show the links */\n}\n\n.navbar ul.hidden {\n    display: none; /* Hide the links */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
